import { useMemo } from 'react';
import { ContentObjectTypes } from 'content-management-data-lib';
import useRouteParams from './useRouteParams';
const PageTypeSlugToContentObjectType = {
  ['landing-page']: ContentObjectTypes.LANDING_PAGE,
  ['site-page']: ContentObjectTypes.SITE_PAGE
};
const usePageContentObjectType = () => {
  const {
    pageTypeSlug
  } = useRouteParams();
  return useMemo(() => PageTypeSlugToContentObjectType[pageTypeSlug], [pageTypeSlug]);
};
export default usePageContentObjectType;